import { useEffect, useState } from "react";

// Site colour trial: true = white site (see src/theme-white.css), false = original black sections.
export const WHITE_THEME = true;
// Palettes on top of the white site:
// "white" = original white site: white backgrounds, black text, amber accents (src/theme-white.css only)
// "sage"  = beige marble, sage green, walnut (src/theme-sage.css)
// "panna" = sabbia, salvia, fango with the 60-30-10 rule (src/theme-panna.css, built on theme-sage.css)
export const PALETTES = ["white", "panna", "sage"];
const DEFAULT = "white";
const KEY = "emma-palette-v2";

// Hidden comparison switch: open the site with ?palette (or ?palette=sage) to show it; the choice is kept in this browser only.
const fromUrl = new URLSearchParams(window.location.search).get("palette");
if (fromUrl !== null) localStorage.setItem("emma-palette-ui", "1");
if (PALETTES.includes(fromUrl)) localStorage.setItem(KEY, fromUrl);

export const getPalette = () => {
  const saved = localStorage.getItem(KEY);
  return PALETTES.includes(saved) ? saved : DEFAULT;
};

const apply = (p) => {
  const c = document.documentElement.classList;
  c.toggle("tw-white", WHITE_THEME);
  c.toggle("tw-sage", WHITE_THEME && p !== "white");
  c.toggle("tw-panna", WHITE_THEME && p === "panna");
};

export const setPalette = (p) => {
  localStorage.setItem(KEY, p);
  apply(p);
  window.dispatchEvent(new CustomEvent("palette-change", { detail: p }));
};

export const usePalette = () => {
  const [p, setP] = useState(getPalette);
  useEffect(() => {
    const on = (e) => setP(e.detail);
    window.addEventListener("palette-change", on);
    return () => window.removeEventListener("palette-change", on);
  }, []);
  return p;
};

apply(getPalette());
